<!-- General page view -->
<script>
  import DataTable from './DataTable.svelte';
  import Header from './UI/Header.svelte';
  import Footer from './UI/Footer.svelte';
  import AfterTable from './UI/AfterTable.svelte';

 //export let name; // This allows the 'name' prop to be passed into App.svelte
</script>
  
  <Header/>

  <div class="page-start-content">
    <p>
      <em>You are here &nbsp;</em>
      <span
        ><a title='ITU' href='https://www.itu.int/en/about/Pages/default.aspx'
          >ITU</a
        ></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a href='https://www.itu.int/en/ITU-R/Pages/default.aspx'>ITU-R</a
        ></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a href='https://www.itu.int/en/ITU-R/space/Pages/default.aspx'
          >Space Services</a
        ></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a
          href='https://www.itu.int/en/ITU-R/space/support/nonGSO/Pages/default.aspx'
          >NGSO</a
        ></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a
          href='https://www.itu.int/ITU-R/go/space-epfd/en'
          >EPFD</a
        ></span
      >
    </p>

    <div>
      <p align='left'>
        For satellite networks subject to Nos. <b>22.5C, 22.5D, 22.5F</b> that have been published in a BRIFIC, here are the additional input data, 
        results files and summary of the Article <b>22</b>, examination with respect to compliance with equivalent power flux density limits.
      </p>
  
      <p align='left'>
        You can find <a
          href='https://www.itu.int/en/ITU-R/space/epfdData/EPFD_E.pdf'
          >the explanation of the different files</a
        >
        and
        <a href='https://www.itu.int/ITU-R/go/space-epfd/en'>information about the EPFD validation</a>.
      </p>
    </div>

  </div>

  <DataTable />

  <AfterTable />

  <Footer/>

  <style>
  .page-start-content {
    margin-left: 20px;
    margin-right: 20px;
    max-width: 100%;    
  }
  </style>